$('.banner .playPause').click(event, function() {
    var playPauseIcon = $(this).find('.icon');
    var iconText = $(this).find('.visually-hidden');
    var findParent = $(this).closest('.banner');

    if (playPauseIcon.hasClass('__pause')) {
        playPauseIcon.removeClass('__pause').addClass('__play');
        iconText.text('Play animation');
        findParent.addClass('__animation-paused');

    }
    else {
        playPauseIcon.removeClass('__play').addClass('__pause');
        iconText.text('Pause animation');
        findParent.removeClass('__animation-paused');
    }
})